import React, { Component, Fragment } from 'react'
import { Card, Col, Button, Form, Jumbotron, Table } from 'react-bootstrap';
import errores from '../../middleware/errordb'
import funciones from '../../middleware/funciones'

import Mensajes from '../subcomponent/mensajes';
import Menu from '../menu'
import config from '../../config';
import ModalConfirm from '../subcomponent/modalConfirm';

export class unidadmedida extends Component {
    constructor(props) {
        super(props)
        const currentCompany = sessionStorage.getItem('company');


        this.state = {
            id: "",
            DESCRIPCION_UNIDAD: "",
            ESTADO: 1,
            proceso: 0,
            listUnidades: [],
            mostrarMensaje: false,
            mensaje: "",
            empresa: currentCompany
        }
    }
    componentDidMount() {
        this.infoUnidades();
    }


    infoUnidades = () => {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo
            }
        }
        fetch(config.servBackEnd + '/units/', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({
                        listUnidades: datos
                    })
                }
            });
    }

    addupdate = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        event.preventDefault();
        const { DESCRIPCION_UNIDAD } = this.state
        const { ESTADO } = this.state

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                DESCRIPCION_UNIDAD,
                ESTADO
            }),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }

        if (this.state.proceso === 0) {
            ruta = config.servBackEnd + '/units/create';
        } else {
            ruta = config.servBackEnd + '/units/modify/' + this.state.id;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                //console.log(data);
                if (data.ok) {
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente" })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Unidad con errores:" + errores[data.code] + " " + data.message })
                }
                this.infoUnidades();
            });
    }

    passtomodify = (data) => {
        //console.log(data);
        this.setState({
            id: data.ID_UNIDADES,
            DESCRIPCION_UNIDAD: data.DESCRIPCION_UNIDAD,
            ESTADO: data.ESTADO,
            proceso: 1
        })
    }
    restartForm = () => {
        this.setState({
            id: "",
            DESCRIPCION_UNIDAD: "",
            ESTADO: 1,
            proceso: 0
        })
    }

    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const msgBoton = (this.state.proceso === 0) ? "Crear" : "Modificar";
        const { listUnidades } = this.state;
        const passtomodify = this.passtomodify;
        const mensajeConfirm = (this.state.proceso === 0) ? '¿Está seguro que desea crear la unidad de medida?' : '¿Está seguro que desea modificar la unidad de medida?';
        return (
            <Fragment>
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>UNIDADES DE MEDIDAS</h2>
                </Jumbotron>
                <Card className="card">
                    <Card.Body>
                        <Form className="form" onSubmit={this.addupdate}>
                            <Form.Row>
                                <Form.Control type="text" value={this.state.id} readOnly hidden/>

                                <Form.Group as={Col} controlId="formGriddescripcion">
                                    <Form.Label>Descripcion</Form.Label>
                                    <Form.Control type="text" placeholder="descripcion" onChange={e => this.setState({ DESCRIPCION_UNIDAD: e.target.value.toUpperCase() })} value={this.state.DESCRIPCION_UNIDAD} required />
                                </Form.Group>
                                <Form.Group as={Col} controlId="formGridestado">
                                    <Form.Label>Estado</Form.Label>
                                    <Form.Control as="select" custom="true" onChange={e => this.setState({ ESTADO: e.target.value })} value={this.state.ESTADO} required>
                                        <option value="1">Activo</option>
                                        <option value="0">Inactivo</option>
                                    </Form.Control>
                                </Form.Group>
                            </Form.Row>
                            <Button variant="primary" className="m-3" type="submit">{msgBoton}</Button>
                            {this.state.proceso !== 0 && <Button onClick={this.restartForm} variant="danger" className="m-3" type="submit">Nuevo</Button>}

                        </Form>
                    </Card.Body>
                </Card>
                <div className="contenedor">
                    {/* <Button className="plus" size="sm" href="/resoluciones/crear/" variant="outline-primary">Crear Resolucion</Button> */}
                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>DESCRIPCION</th>
                                <th>ESTADO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {listUnidades.map(function (currentData, index) {
                                return <tr key={index + "d0"}>
                                    <td key={index + "d1"}>{(index + 1)}</td>
                                    <td key={index + "d2"}>{currentData.DESCRIPCION_UNIDAD}</td>
                                    <td key={index + "d5"}>{funciones.textEstadoGeneral(currentData.ESTADO)}</td>
                                    <td><Button onClick={() => passtomodify(currentData)} size="sm" variant="outline-primary">Editar</Button></td>
                                </tr>;
                            })}
                        </tbody>
                    </Table>
                </div>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </Fragment>
        )
    }
}

export default unidadmedida
